export default __webpack_public_path__ + "static/media/hide.3a11698f.svg";